module.exports = __webpack_public_path__ + "img/532.9506f401.jpg";